import { forwardRef } from "react";
import { type ActivityOption } from "~/types/common";

interface ActivityRadioNewProps {
  value?: ActivityOption | null;
  onChange?: (value: ActivityOption | null) => void;
  options: ActivityOption[];
  colorIdx?: number;
}

const orange = "border-orange-400 text-orange-500 bg-white";
const gray = "border-gray-300 text-gray-500 bg-white";
const empty = "border-transparent bg-transparent cursor-default";

const ActivityRadioNew = forwardRef<HTMLDivElement, ActivityRadioNewProps>(
  ({ value, onChange, options }, ref) => {
    const displayOptions =
      options.length === 2
        ? [
            ...options,
            { cdActivityValue: "__empty__", value: "", selected: false },
          ]
        : options;

    return (
      <div className="flex col-span-4 gap-2" ref={ref}>
        {displayOptions.map((opt) =>
          opt.cdActivityValue === "__empty__" ? (
            <button
              key="empty"
              type="button"
              className={`flex-1 px-2 py-1 text-sm font-medium rounded border transition-all ${empty}`}
              tabIndex={-1}
              disabled
              aria-hidden
            >
              &nbsp;
            </button>
          ) : (
            <button
              key={opt.cdActivityValue}
              type="button"
              className={`flex-1 px-2 py-1 rounded border text-sm font-medium transition-all text-[#999]
                ${value?.cdActivityValue === opt.cdActivityValue ? orange : gray}
              `}
              onClick={() =>
                onChange?.(
                  value?.cdActivityValue === opt.cdActivityValue ? null : opt
                )
              }
            >
              {opt.value}
            </button>
          )
        )}
      </div>
    );
  }
);

export default ActivityRadioNew;
